import AttendanceLayout from "@/views/layouts/attendance.vue";
import MedicalRecord from "@/views/medical_record/index.vue";
import PreExam from "@/views/medical_record/pre_exam.vue";
import HMA from "@/views/medical_record/hma.vue";
import HPP from "@/views/medical_record/hpp.vue";
import HF from "@/views/medical_record/hf.vue";
import HD from "@/views/medical_record/hd.vue";
import Biomicroscopy from "@/views/medical_record/biomicroscopy.vue";
import Biomicroscopy2 from "@/views/medical_record/biomicroscopy2.vue";

import Fundoscopy from "@/views/medical_record/fundoscopy.vue";
import Fundoscopy2 from "@/views/medical_record/fundoscopy2.vue";
import AVRefr from "@/views/medical_record/avrefr.vue";
import PRCM from "@/views/medical_record/prcm.vue";
import Conduct from "@/views/medical_record/conduct.vue";
import Sumary from "@/views/medical_record/sumary.vue";

import therapy from "./therapy.js";
import prescription from "./prescription.js";
import glassesPrescription from "./glasses_prescription.js";
import patientMoviment from "./patient_moviment.js";
import medicalCertificate from "./medical_certificate.js";
import exam from "./exam.js";
import treatment from "./treatment.js";
import medicalRequest from "./medical_request.js";
import contactLensTests from "./contact_lens_test.js";
import surgeryIndication from "./surgery_indication.js";
import report from "./report.js";
import surgery from "./surgery.js";

export default [
  {
    path: "/prontuario/:attendance_id",
    component: AttendanceLayout,
    children: [
      {
        path: "",
        name: "Prontuário",
        component: MedicalRecord,
        children: [
          {
            path: "geral",
            name: "Geral",
            component: Sumary,
            meta: { backTo: "/filas/ilha/gerals" },
          },
          {
            path: "pre-exame",
            name: "Pré Exame",
            component: PreExam,
            meta: { backTo: "/filas/ilha/pre-exames" },
          },
          {
            path: "hma",
            name: "História da moléstia atual",
            component: HMA,
            meta: { backTo: "/filas/medico" },
          },
          {
            path: "hpp",
            name: "História da patológica pregressa",
            component: HPP,
            meta: { backTo: "/filas/medico" },
          },
          {
            path: "hf",
            name: "Histórico Familiar",
            component: HF,
            meta: { backTo: "/filas/medico" },
          },
          {
            path: "hd",
            name: "Hipotese Diagnóstica",
            component: HD,
            meta: { backTo: "/filas/medico" },
          },
          {
            path: "biomicroscopia",
            name: "Biomicroscopia",
            component: Biomicroscopy,
            meta: { backTo: "/filas/medico" },
          },
          {
            path: "biomicroscopia2",
            name: "Biomicroscopia2",
            component: Biomicroscopy2,
            meta: { backTo: "/filas/medico" },
          },

          {
            path: "fundoscopia",
            name: "Fundoscopia",
            component: Fundoscopy,
            meta: { backTo: "/filas/medico" },
          },
          
          {
            path: "fundoscopia2",
            name: "Fundoscopia2",
            component: Fundoscopy2,
            meta: { backTo: "/filas/medico" },
          },
          {
            path: "prcm",
            name: "prcm",
            component: PRCM,
            meta: { backTo: "/filas/medico" },
          },
          {
            path: "avrefr",
            name: "Acuidade Visual e Refração",
            component: AVRefr,
            meta: { backTo: "/filas/medico" },
          },
          {
            path: "conduta",
            name: "Conduta",
            component: Conduct,
            meta: { backTo: "/filas/medico" },
          },
        ].concat(exam, treatment, surgeryIndication, report),
      },
    ].concat(
      therapy,
      prescription,
      glassesPrescription,
      medicalCertificate,
      medicalRequest,
      contactLensTests,
      surgery,
      patientMoviment
    ),
  },
];
